import React from 'react';
import { Dropdown, Button, Menu, Icon, Tooltip } from 'antd';
import { toggleFilterVisble, resetFilter } from '../../../../features/filter';
import styles from './OpenFilterWithActions.module.scss';

const { OpenFilter } = toggleFilterVisble;
const { ResetFilter } = resetFilter;

const OverlayActions = (props) => {
  return (
    <Menu {...props}>
      <ResetFilter
        render={({ reset, ...props }) => (
          <Menu.Item
            {...props}
            onClick={reset}
          >
            <Icon
              type="sync"
              className={styles.icon}
            />
            Сбросить фильтр
          </Menu.Item>
        )}
      />
    </Menu>
  );
};

const OpenFilterWithActions = () => {
  return (
    <Dropdown
      overlay={<OverlayActions />}
      placement="bottomLeft"
    >
      <OpenFilter
        render={({ openFilter, ...props }) => (
          <Tooltip
            title="Открыть фильтр"
            placement="topRight"
          >
            <Button
              {...props}
              icon="filter"
              onClick={openFilter}
            />
          </Tooltip>
        )}
      />
    </Dropdown>
  );
};

export default OpenFilterWithActions;
